import React, { useState } from 'react';
import { FieldType } from 'components/Form';
import useAuthentication from 'modules/auth/hooks/useAuthentication';
import useInstanceConfig from 'modules/siteConfig/hooks/useInstanceConfig';
import AuthErrors from 'types/enums/AuthErrors';
import isEmail from 'validator/lib/isEmail';

import { Box } from '@lyearn/ui';

const initialValue = {
  email: '',
};

const formFields = {
  email: {
    name: 'email',
    placeholder: 'Enter your email',
    label: 'Email',
    type: FieldType.Email,
  },
} as const;

const validate = (values: TSFixMe) => {
  const errors: any = {};
  if (!values.email) {
    errors.email = 'Required';
  }
  if (!isEmail(values.email)) {
    errors.email = 'Invalid Email';
  }
  return errors;
};

const useForgotPasswordForm = () => {
  const { handleForgotPassword, handleLookupEmail } = useAuthentication();
  const { site } = useInstanceConfig();
  const [passwordLinkSentStatus, setPasswordLink] = useState({ show: false, emailId: '' });

  const onSubmit = async (values: TSFixMe, formHelpers: TSFixMe) => {
    const { /* password, */ email: emailId } = values;
    const { setFieldError } = formHelpers;
    const emailError = await (handleLookupEmail as any)({ emailId });
    if (emailError) {
      if (
        emailError.errorCode === AuthErrors.ACCOUNT_NOT_FOUND ||
        emailError.errorCode === AuthErrors.INVALID_DATA
      ) {
        setFieldError(
          'email',
          <Box component="span">
            Email not registered with us. Try{' '}
            <a className="textlink-external underline" href="/signup">
              creating a new account
            </a>
          </Box>,
        );
      }
    } else {
      const error = await handleForgotPassword({
        emailId,
        subDomain: site.subdomain,
        storeName: site.storeName,
        host: window.location.host,
      });
      if (!error) {
        setPasswordLink({ show: true, emailId });
      }
    }
    // await (handleLogin as any)(
    //   { emailId, password },
    //   handleClose,
    //   redirectPath
    // );
  };

  return { formFields, initialValue, validate, onSubmit, passwordLinkSentStatus };
};

export default useForgotPasswordForm;
